import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import Title from "@components/global/new/Title/Title";
import { MODALS_ENUM } from "@constants/Modals";
import styles from "./ChangeClientPasswordMoal.module.scss";
import Button from "@components/global/new/Button/Button";
import { useChangeClientPasswordModalControl } from "./useChangeClientPasswordModalControl";
import Error from "@components/global/new/Error/Error";

export interface IChangeClientPasswordModalProps extends CommonModalPropsI {
  readonly userId: string;
}

function ChangeClientPasswordModal(props: IChangeClientPasswordModalProps) {
  const { formatMessage } = props;
  const control = useChangeClientPasswordModalControl(props);

  return (
    <div className={styles.wrapper}>
      <Title className={styles.title}>
        {formatMessage({ id: "modal.change_pass.title" })}
      </Title>

      <div className={styles.input}>
        <input
          value={control.password}
          onChange={control.onChangehandler}
          placeholder={formatMessage({ id: "modal.change_pass.placeholder" })}
        />
      </div>

      {control.errors && <Error errors={control.errors} />}

      <div className={styles.btns}>
        <Button
          className={styles.btn}
          onClick={control.onChangePass}
          loading={control.loading}
        >
          {formatMessage({ id: "modal.change_pass.save" })}
        </Button>
        <Button className={styles.btn} red onClick={props.handleClose}>
          {formatMessage({ id: "modal.change_pass.cancel" })}
        </Button>
      </div>
    </div>
  );
}

export default WithModal(
  MODALS_ENUM.CHANGE_CLIENT_PASSWORD_MODAL,
  ChangeClientPasswordModal
);
